<template>
  <div v-bind:class="{loading: isLoading}" id="view-category" class="columns">
    <div class="column">
      <h2 class="subtitle" id="set-anchor">{{ setName }}</h2>
      <div v-if="notification" class="notification is-info">
        <button @click="notification = ''" class="delete"></button>
        {{ notification }}
      </div>
      <table class="table">
        <thead>
          <tr>
            <th width="50"></th>
            <th width="75">Qty</th>
            <th class="clickable" @click="sortBy('card-name')">Name</th>
            <th class="clickable" @click="sortBy('rarity')">Rarity</th>
            <th class="clickable" @click="sortBy('condition')">Cond</th>
            <th class="clickable" @click="sortBy('price')">Price</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="p in orderedProducts">
            <td><button :disabled="!p.quantity || Number(p.quantity) < 1" @click.prevent="addToCart(p)" class="button is-primary"><i class="fa fa-cart-plus" aria-hidden="true"></i></button></td>
            <td><input class="input quantity" type="number" v-model.number="p.quantity"></td>
            <td>{{ p.card_name }}</td>
            <td>{{ p.rarity }}</td>
            <td>{{ p.condition }}</td>
            <td>{{ p.buylist_price }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Raven from 'raven-js';
import addToBuylistCart from '@/addToBuylistCart';
import CardTitle from './partials/CardTitle';

export default {
  name: 'SellViewCategory',
  data() {
    return {
      isLoading: false,
      category: {},
      products: [],
      cart: {},
      client: null,
      setName: '',
      notification: '',

      sortKey: '',
      sortDirection: 1, // -1 for reverse
    };
  },
  components: {
    'card-title': CardTitle,
  },
  computed: {
    orderedProducts() {
      if (!this.sortKey) {
        return this.products;
      }

      const sk = this.sortKey;
      const getValue = (k, o) => {
        if (k === 'card-name') {
          return o.card_name;
        } else if (k === 'condition') {
          return o.condition;
        } else if (k === 'price') {
          return Number(o.buylist_price.substr(1));
        }

        return '';
      };

      return this.products.sort((a, b) => {
        if (getValue(sk, a) < getValue(sk, b)) {
          return 1 * this.sortDirection;
        } else if (getValue(sk, a) > getValue(sk, b)) {
          return -1 * this.sortDirection;
        }

        return 0;
      });
    },
  },
  methods: {
    addToCart(p) {
      addToBuylistCart(this.$localStorage, p);
      this.notification = `${p.card_name} has been added to your buylist order cart.`;
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortDirection = this.sortDirection * -1;
    },
    loadSet(id) {
      this.isLoading = true;
      this.setName = '';
      this.products = [];

      this.axios.get(`https://inventory.powernine.com/shopify/buylist/${id}`).then((response) => {
        this.setName = response.data.name;

        response.data.products.forEach((p) => {
          const li = p;
          li.quantity = 0;
          this.products.push(li);
        });

        this.isLoading = false;
        document.getElementById('set-anchor').scrollIntoView();
      })
      .catch((err) => {
        this.isLoading = false;
        Raven.captureException(err);
        throw err;
      });
    },
  },
  mounted() {
    this.loadSet(this.$route.params.id);
  },
  watch: {
    // eslint-disable-next-line
    '$route': function (to) {
      this.loadSet(to.params.id);
    },
  },
};
</script>



// WEBPACK FOOTER //
// SellViewCategory.vue?5295aa61